/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import Select from 'react-select';

import ClientsAction from '../../../app/store/actions/clients';
import FIELDS from '../../../data/fields';
import randomPassword from '../../../helpers/generator';
import TRANSLATE from '../../../helpers/translate';
import MultiSelect from '../../multi-select/MultiSelect';
import SelectComponent from '../../select/Select';
import ApproveLimitComponent from './ApproveLimitComponent';
import VALIDATION from './helper/Validation';

let clientHelper = '';

class ClientFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        clientId: '',
        status: 'active',
        freight: '',
        paymentTerms: '',
        locationId: '',
        deposit: '',
        mainDeposit: '',
        bu: '',
        pricePolicy: '',
        purpose: '',
        emails: '',
        displayClientDescription: '',
        showContractProductWithoutPrice: '',
        allowSellSpotItensWithoutStock: '',
        clientWithdraw: '',
        buyButtonLabel: I18n.t('addEstimateBuy'),
        fileGenerator: '',
        fileEmailJson: 0,
        fileEmailXml: 0,
        fileEmailCsv: 0,
        fileEmailPdf: 0,
        nickname: '',
        minimumPurchase: 0,
        minimumProduct: 0,
        orderType: 0,
        deliveryAddressType: 0,
        internalDeliveryAddress: 0,
        autoBilling: 0,
        customerUnit: 0,
        projectsForIntegrators: 0,
        punchoutRule: '',
        punchoutN2Rule: '',
        punchoutVendorId: '',
        newItemVendor: '',
        newItemContract: '',
        productCatalogPunchout: 0,
        punchoutCatalogName: '',
        // maximumContractLimit: '0',
        limits: [],
        newLogoUrl: '',
      },
      value: '',
      listClient: '',
      message: '',
      success: '',
      update: false,
      file: null,
      oldLogoUrl: '',
      completeLogoUrl: '',
      stateUF: '',
    };
  }

  componentDidMount() {
    if (this.props.back.location.item) {
      this.setClientUpdate(this.props.back.location.item);
    } else {
      this.props.getClientSettings();
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.clients) {
      if (!prevState.listClient || (prevState.listClient !== this.state.listClient)) {
        this.renameDepositKeyForComponent(this.props.clients.stock[0]);
      }
    }
  }

  setClientUpdate = async (item) => {
    const { companyTag } = this.props;
    const { form } = this.state;
    const oldLogoUrl = item.logoUrl || '';
    const completeLogoUrl = item.completeLogoUrl || '';
    form.clientId = item.clientId;
    form.freight = item.freight;
    form.paymentTerms = item.sphereClient.paymentTermsCode;
    form.locationId = item.locationId;
    form.places = item.places;
    form.deposit = item.deposit;
    form.mainDeposit = item.mainDeposit;
    form.bu = item.bu;
    form.pricePolicy = item.pricePolicy;
    form.purpose = item.purpose;
    form.emails = item.emails;
    form.buyButtonLabel = item.buyButtonLabel;
    form.displayClientDescription = item.displayClientDescription ? 1 : 0;
    form.showContractProductWithoutPrice = item.showContractProductWithoutPrice ? 1 : 0;
    form.allowSellSpotItensWithoutStock = item.allowSellSpotItensWithoutStock ? 1 : 0;
    form.clientWithdraw = item.clientWithdraw ? 1 : 0;
    form.fileEmailCsv = item.fileEmailCsv ? 1 : 0;
    form.fileEmailPdf = item.fileEmailPdf ? 1 : 0;
    form.fileEmailXml = item.fileEmailXml ? 1 : 0;
    form.fileEmailJson = item.fileEmailJson ? 1 : 0;
    form.status = item.status;
    form.nickname = item.nickname;
    form.minimumPurchase = item.minimumPurchase;
    form.minimumProduct = item.minimumProduct;
    form.orderType = item.orderType ? 1 : 0;
    form.deliveryAddressType = item.deliveryAddressType ? 1 : 0,
    form.internalDeliveryAddress = item.internalDeliveryAddress ? 1 : 0,
    form.autoBilling = item.autoBilling ? 1 : 0;
    form.customerUnit = item.customerUnit ? 1 : 0;
    form.projectsForIntegrators = item.projectsForIntegrators ? 1 : 0,
    form.punchoutRule = item.punchoutRule;
    form.punchoutN2Rule = item.punchoutN2Rule;
    form.punchoutVendorId = item.punchoutVendorId;
    form.newItemVendor = item.newItemVendor;
    form.newItemContract = item.newItemContract;
    form.productCatalogPunchout = item.productCatalogPunchout ? 1 : 0;
    form.punchoutCatalogName = item.punchoutCatalogName;
    // form.maximumContractLimit = item.maximumContractLimit;
    form.limits = item.limits || [];
    item.deposit = item.deposit.toUpperCase();

    if (companyTag === 'nortel') {
      if (item.sphereClient.state === 'SP' && item.locationId === '04029') {
        form.locationId = '';
      } else if (item.locationId === '04097' && item.sphereClient.state !== 'SP') {
        form.locationId = '';
      }
    }

    await this.props.getClientSettings();
    await this.setState({
      form,
      oldLogoUrl,
      completeLogoUrl,
      message: '',
      update: true,
      value: `${item.sphereClient.id} ${item.sphereClient.name} - 
      [${item.sphereClient.cnpj}], ${item.sphereClient.city}`,
      checked: item.deposit ? item.deposit.split(',') : false,
      checkedPlaces: item.places ? item.places.split(',') : [],
      stateUF: (companyTag === 'nortel') ? item.sphereClient.state : '',
    });
  }

  goBack = () => {
    this.props.back.goBack();
  }

  selectedItem = (attr, value) => {
    const { form } = this.state;
    if (attr === 'fileEmailXml') {
      if (form.fileEmailXml) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'fileEmailCsv') {
      if (form.fileEmailCsv) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'fileEmailPdf') {
      if (form.fileEmailPdf) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'fileEmailJson') {
      if (form.fileEmailJson) {
        form[attr] = 0;
      } else {
        form[attr] = 1;
      }
    } else if (attr === 'productCatalogPunchout') {
      form[attr] = value.target.value == '1' ? 1 : 0;
    } else if (attr === 'orderType' || attr === 'projectsForIntegrators') {
      form[attr] = value.target.value == '1' ? 1 : 0;
    } else if (attr === 'deliveryAddressType') {
      form[attr] = value.target.value === '1' ? 1 : 0;
    } else if (attr === 'internalDeliveryAddress') {
      form[attr] = value.target.value === '1' ? 1 : 0;
    } else form[attr] = value.target.value;

    this.setState({ form, message: '', success: '' });
  }

  saveClient = async (type) => {
    const { goalOff, companyTag } = this.props;
    const { form, file, oldLogoUrl } = this.state;
    const {
      displayClientDescription, showContractProductWithoutPrice,
      allowSellSpotItensWithoutStock, clientWithdraw,
    } = this.state.form;

    form.displayClientDescription = displayClientDescription ? Number(displayClientDescription) : '';
    form.showContractProductWithoutPrice = showContractProductWithoutPrice ? Number(showContractProductWithoutPrice) : 0;
    form.allowSellSpotItensWithoutStock = allowSellSpotItensWithoutStock ? Number(allowSellSpotItensWithoutStock) : 0;
    form.clientWithdraw = clientWithdraw ? Number(clientWithdraw) : 0;

    if (companyTag === 'nortel') {
      if (file) {
        const image = await this.uploadedFile(file, form.clientId);
        form.newLogoUrl = image || '';
      } else {
        form.newLogoUrl = oldLogoUrl;
      }

      await this.setState({ form });
    }

    const client = await VALIDATION.validation(form, goalOff, { companyTag }, file);

    if (client.message) {
      this.setState({ message: client.message, success: '' });
    } else if (type === 'create') {
      try {
        await this.props.createClient(client);
        this.setState({
          success: I18n.t('clientCreated'),
          message: '',
          form: {
            clientId: '',
            status: 'active',
            freight: '',
            paymentTerms: '',
            locationId: '',
            places: '',
            deposit: '',
            mainDeposit: '',
            bu: '',
            pricePolicy: '',
            purpose: '',
            emails: '',
            displayClientDescription: '',
            showContractProductWithoutPrice: '',
            allowSellSpotItensWithoutStock: '',
            clientWithdraw: '',
            buyButtonLabel: I18n.t('addEstimateBuy'),
            fileGenerator: '',
            fileEmailXml: 0,
            fileEmailCsv: 0,
            fileEmailPdf: 0,
            fileEmailJson: 0,
            nickname: '',
            minimumPurchase: 0,
            minimumProduct: 0,
            orderType: 0,
            deliveryAddressType: 0,
            internalDeliveryAddress: 0,
            autoBilling: 0,
            customerUnit: 0,
            projectsForIntegrators: 0,
            punchoutRule: '',
            punchoutN2Rule: '',
            punchoutVendorId: '',
            newItemVendor: '',
            newItemContract: '',
            productCatalogPunchout: 0,
            punchoutCatalogName: '',
            // maximumContractLimit: '0',
            limits: [],
            newLogoUrl: '',
          },
          value: '',
          listClient: '',
          checked: '',
          checkedPlaces: '',
          file: null,
        });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    } else if (type === 'update') {
      try {
        await this.props.updateClient(client);
        this.setState({ success: I18n.t('successActualized'), message: '' });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    } else {
      this.setState({ message: I18n.t('errorOcurred'), success: '' });
    }
  };

  newLimit = () => {
    const { form } = this.state;
    form.limits.push({ limit: 0.00 });
    this.setState({ form });
  }

  setLimit = (limit, index) => {
    const { form } = this.state;
    form.limits[index].limit = limit.floatValue;
    this.setState({
      form,
    });
  }

  setMinimumPurchase = (minimum) => {
    const { form } = this.state;
    form.minimumPurchase = minimum.floatValue;
    this.setState({
      form,
    });
  }

  setMinimumProduct = (minimum) => {
    const { form } = this.state;
    form.minimumProduct = minimum.floatValue;
    this.setState({
      form,
    });
  }

  removeLimit = (index) => {
    const { form } = this.state;
    form.limits.splice(index, 1);
    this.setState({
      form,
    });
  }

  setSearchOnChange = (value) => {
    const { form } = this.state;
    form.clientId = clientHelper.id;
    if (value) this.props.searchSphereClient(10, value);
    this.setState({ value, form });
  }

  setSelectedSphereClient = async (e) => {
    const { form } = this.state;
    form.clientId = clientHelper.id;
    form.paymentTerms = clientHelper.paymentTermsCode;
    await this.setState({
      value: e.value,
      form,
      message: '',
      success: '',
    });
  }

  setSelectedClientGlobal = (item) => {
    const { companyTag } = this.props;
    const { form } = this.state;
    clientHelper = item;
    if (companyTag === 'nortel' && item.state !== this.state.stateUF) {
      form.locationId = '';
      this.setState({
        stateUF: item.state,
        form: { ...form },
      });
    }
    return `${item.id} ${item.name} - [${item.cnpj}], ${item.city}`;
  }

  getPtbr = (values, val, id) => {
    if (id === 'purpose') {
      return TRANSLATE.clientPurpose(values[val]);
    } if (id === 'freight') {
      return TRANSLATE.clientFreight(values[val]);
    }
    return values[val];
  }

  getValues =
    values => (values.map(val => (<option key={val.id + val.description} value={val.id}>{val.description}</option>)));

  getValuesRules =
    values => (values.map(val => (<option key={val.code} value={val.code}>{val.name}</option>)));

  getValuesDeposit =
    values => (values.map(val => (<option key={val.value} value={val.value}>{val.value}</option>)));

  getValuesLocation = (values) => {
    const { companyTag } = this.props;
    if (companyTag === 'nortel') {
      return (
        values.map((val) => {
          if (val.id === '04097' && this.state.stateUF === 'SP') {
            return (
              <option key={val.id + val.crmTag} value={val.id}>
                {val.crmTag ? val.crmTag
                  : `${val.id} - ${val.city}`}
              </option>
            );
          }
          if (val.id === '04029' && this.state.stateUF !== 'SP') {
            return (
              <option key={val.id + val.crmTag} value={val.id}>
                {val.crmTag ? val.crmTag
                  : `${val.id} - ${val.city}`}
              </option>
            );
          }
          if (!this.state.stateUF || (val.id !== '04097' && val.id !== '04029')) {
            return (
              <option key={val.id + val.crmTag} value={val.id}>
                {val.crmTag ? val.crmTag
                  : `${val.id} - ${val.city}`}
              </option>
            );
          }
        }));
    }
    return (
      values.map(val => (
        <option key={val.id + val.crmTag} value={val.id}>
          {val.crmTag ? val.crmTag
            : `${val.id} - ${val.city}`}
        </option>
      )));
  };

  getObjValues =
    (values, id) => (Object.keys(values).map(val => (
      <option key={values[val]} value={values[val]}>{this.getPtbr(values, val, id)}</option>)));

  getValuesObj =
    values => ([{ label: '', value: '' }].concat(values.map(val => ({ label: val.description, value: val.id }))));

  result = async (params) => {
    const { form } = this.state;
    form.deposit = params.toString();

    if (this.props.companyTag && this.props.companyTag !== 'chile') {
      if (!form.deposit.includes(this.state.form.mainDeposit)) {
        form.mainDeposit = '';
      }
    }

    await this.setState({
      form,
      checked: params,
      message: '',
      success: '',
    });
  }

  resultLocation = async (params) => {
    const { form } = this.state;
    form.places = params.toString();
    await this.setState({
      form,
      checkedPlaces: params,
      message: '',
      success: '',
    });
  }

  renameDepositKeyForComponent = async (client) => {
    if (!this.state.listClient) {
      client.forEach((x) => {
        x.name = (x.value).toUpperCase();
        x.value = (x.name).toUpperCase();
      });

      await this.setState({ listClient: client });
    }
  }

  getDepositTags = (tags) => {
    if (tags) {
      const tag = tags.split(',');
      return tag.map(tg => (<div className="chip-body"><p className="chip-text">{tg}</p></div>));
    }
  }

  getSelectComponent = (title, attr, value, body, tooltip, disabled = false) => (
    <SelectComponent
      title={title}
      value={value}
      body={body}
      onChange={e => this.selectedItem(attr, e)}
      tooltip={tooltip}
      disabled={disabled}
    />
  )

  deleteFile = async () => {
    const { form } = this.state;
    form.newLogoUrl = '';
    await this.setState({
      form,
      file: null,
      oldLogoUrl: null,
    });
  }

  onFileChange = async (event) => {
    if (event.target.files && event.target.files[0]) {
      const image = event.target.files[0];
      await this.setState({ file: image });
    }
  };

  uploadedFile = async (file, id) => {
    if (!file) {
      this.setState({ message: I18n.t('fileError'), success: '' });
      return '';
    }
    try {
      const { opico } = this.props;
      const hash = randomPassword();
      const extension = file.name.split('.').pop();
      const name = `${opico}${hash}.${extension}`;
      const image = await ClientsAction.uploadClientLogo(file, name, id);

      return image.name;
    } catch (err) {
      await this.setState({ message: I18n.t('errorAttachingFile'), success: '' });
      return '';
    }
  }

  render() {
    const {
      message, success, value,
      listClient, update, checked,
      checkedPlaces, oldLogoUrl, completeLogoUrl,
      file,
    } = this.state;

    const {
      freight, paymentTerms, locationId,
      bu, fileEmailXml, fileEmailJson,
      pricePolicy, displayClientDescription, purpose,
      emails, buyButtonLabel, fileEmailPdf,
      fileEmailCsv, nickname, showContractProductWithoutPrice,
      allowSellSpotItensWithoutStock, clientWithdraw, minimumPurchase,
      minimumProduct, orderType, autoBilling,
      customerUnit, punchoutRule, punchoutN2Rule, projectsForIntegrators,
      punchoutVendorId, newItemVendor, newItemContract,
      mainDeposit, productCatalogPunchout, punchoutCatalogName,
      newLogoUrl, deliveryAddressType, internalDeliveryAddress,
    } = this.state.form;

    const {
      clients, searched, rules, rulesN2, goalOff, companyTag,
    } = this.props;

    return (
      <React.Fragment>
        <form>
          <div className="form-group autocomplete-client">
            <p className="margin-bottom-2">
              <Translate value="client" />
            </p>
            {update ? (
              <input
                type="text"
                disabled
                className="form-control"
                placeholder={value}
                maxLength={FIELDS.max}
              />
            ) : (
              <Autocomplete
                getItemValue={(item) => this.setSelectedClientGlobal(item)}
                items={searched || []}
                className="custom-select autocomplete-custom"
                renderItem={(item, isHighlighted) => (
                  <div
                    key={item.cnpj}
                    style={{
                      background: isHighlighted ? "lightgray" : "white",
                    }}
                  >
                    {`${item.id} ${item.name} - [${item.cnpj}], ${item.city}`}
                  </div>
                )}
                value={value}
                onChange={(e) => this.setSearchOnChange(e.target.value)}
                onSelect={(e) =>
                  this.setSelectedSphereClient({ value: e, message: "" })
                }
                maxLength={FIELDS.default}
              />
            )}
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="nickname" />
            </p>
            <input
              onChange={(e) => this.selectedItem("nickname", e)}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={nickname || ""}
              maxLength={FIELDS.default}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("companyLogo")}</p>
            <div
              className="form-control"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label htmlFor="selecao-arquivo" style={{ margin: "0px" }}>
                <span
                  style={{
                    marginRight: "5px",
                    background: "#F0F0F0",
                    padding: "1px 6px",
                    fontWeight: "400",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  {I18n.t("chooseFile")}
                </span>
              </label>

              <span style={{ marginRight: "7px", overflow: "hidden" }}>
                {file
                  ? file.name
                  : newLogoUrl || oldLogoUrl || I18n.t("logoCurrentlyActive")}
              </span>

              {(oldLogoUrl || newLogoUrl) && (
                <button
                  style={{
                    padding: "0px",
                    border: "none",
                    color: "red",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                  type="button"
                  onClick={this.deleteFile}
                >
                  X
                </button>
              )}

              <input
                type="file"
                onChange={(event) => this.onFileChange(event)}
                id="selecao-arquivo"
                style={{ display: "none" }}
                accept="image/png, image/jpeg, image/jpg"
              />
            </div>
          </div>

          {clients &&
            this.getSelectComponent(
              I18n.t("freightType"),
              "freight",
              freight,
              this.getObjValues(clients.ClientFreights, "freight"),
              I18n.t("freightTypeObs")
            )}

          {clients &&
            this.getSelectComponent(
              I18n.t("paymentCondition"),
              "paymentTerms",
              paymentTerms,
              this.getValues(clients.paymentTerms),
              I18n.t('toolTipPayments'),
              true,
            )}

          {companyTag === "dimensional"
            ? clients && (
                <React.Fragment>
                  <div className="form-group">
                    <p
                      style={{ marginBottom: "0px" }}
                      className="margin-bottom-2"
                    >
                      <Translate value="place" />
                    </p>
                    <MultiSelect
                      options={clients.location.length ? clients.location : []}
                      checked={checkedPlaces}
                      onSelectOptions={this.resultLocation}
                      className="form-control multiSelect-input"
                    />
                  </div>
                  {checkedPlaces &&
                    this.getSelectComponent(
                      I18n.t("mainPlace"),
                      "locationId",
                      locationId,
                      this.getValues(
                        checkedPlaces
                          ? checkedPlaces.map((i) => ({
                              id: i,
                              description: i,
                            }))
                          : []
                      )
                    )}
                </React.Fragment>
              )
            : clients &&
              this.getSelectComponent(
                I18n.t("place"),
                "locationId",
                locationId,
                this.getValuesLocation(clients.location)
              )}

          {clients &&
            this.getSelectComponent(
              I18n.t("bu"),
              "bu",
              bu,
              this.getValues(clients.bus)
            )}

          {clients &&
            companyTag === "dimensional" &&
            this.getSelectComponent(
              I18n.t("policy"),
              "pricePolicy",
              pricePolicy,
              this.getValues(clients.pricePolicies)
            )}

          {clients && companyTag === "chile" && (
            <span>
              <p className="margin-bottom-2">{I18n.t("policy")}</p>
              <Select
                onChange={(e) => {
                  const { form } = this.state;
                  form.pricePolicy = e.value;
                  this.setState({ form, message: "", success: "" });
                }}
                options={this.getValuesObj(clients.pricePolicies)}
                value={{
                  label:
                    clients &&
                    (
                      clients.pricePolicies.find(
                        (val) => val.id == pricePolicy
                      ) || []
                    ).description,
                  value: pricePolicy,
                }}
              />
              <p />
            </span>
          )}

          {clients &&
            !goalOff &&
            this.getSelectComponent(
              I18n.t("purpose"),
              "purpose",
              purpose,
              this.getObjValues(clients.ClientPurposes, "purpose")
            )}

          <div className="row row-solicitation-check">
            <div className="form-check" style={{ marginRight: "5px" }}>
              <input
                onChange={(e) => this.selectedItem("fileEmailXml", e)}
                type="checkbox"
                className="form-check-input"
                checked={!!fileEmailXml}
                id="exampleCheck1"
              />
              <span>XML</span>
            </div>

            <div className="form-check" style={{ marginRight: "5px" }}>
              <input
                onChange={(e) => this.selectedItem("fileEmailCsv", e)}
                type="checkbox"
                className="form-check-input"
                checked={!!fileEmailCsv}
                id="exampleCheck1"
              />
              <span>CSV</span>
            </div>

            <div className="form-check" style={{ marginRight: "5px" }}>
              <input
                onChange={(e) => this.selectedItem("fileEmailPdf", e)}
                type="checkbox"
                className="form-check-input"
                checked={!!fileEmailPdf}
                id="exampleCheck1"
              />
              <span>PDF</span>
            </div>

            <div className="form-check" style={{ marginRight: "5px" }}>
              <input
                onChange={(e) => this.selectedItem("fileEmailJson", e)}
                type="checkbox"
                className="form-check-input"
                checked={!!fileEmailJson}
                id="exampleCheck1"
              />
              <span>JSON</span>
            </div>
          </div>

          {listClient && checked && (
            <div className="form-group">
              <p style={{ marginBottom: "0px" }} className="margin-bottom-2">
                <Translate value="deposit" />
              </p>
              <MultiSelect
                options={listClient}
                checked={checked}
                onSelectOptions={this.result}
                className="form-control multiSelect-input"
              />
            </div>
          )}

          {listClient && !this.props.back.location.item && !checked && (
            <div className="form-group">
              <p style={{ marginBottom: "0px" }} className="margin-bottom-2">
                <Translate value="deposit" />
              </p>
              <MultiSelect
                options={listClient}
                checked={[]}
                onSelectOptions={this.result}
                className="form-control multiSelect-input"
              />
            </div>
          )}

          {companyTag !== "chile" &&
            this.getSelectComponent(
              I18n.t("mainDeposit"),
              "mainDeposit",
              mainDeposit ? mainDeposit.toUpperCase() : "",
              this.getValues(
                checked ? checked.map((i) => ({ id: i, description: i })) : []
              )
            )}

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="emails" />
            </p>
            <textarea
              value={emails}
              onChange={(e) => this.selectedItem("emails", e)}
              className="form-control"
              placeholder={I18n.t("separateBySemicolon")}
              rows="3"
              maxLength={
                companyTag === "dimensional" ? FIELDS.emails : FIELDS.max
              }
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="buyButton" />
            </p>
            <input
              onChange={(e) => this.selectedItem("buyButtonLabel", e)}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={buyButtonLabel}
              maxLength={FIELDS.default}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="showClientDescription" />
            </p>
            <select
              onChange={(e) => this.selectedItem("displayClientDescription", e)}
              className="custom-select"
              value={displayClientDescription}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="showContractProductWithoutPrice" />
            </p>
            <select
              onChange={(e) =>
                this.selectedItem("showContractProductWithoutPrice", e)
              }
              className="custom-select"
              value={showContractProductWithoutPrice}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="allowSellSpotItensWithoutStock" />
            </p>
            <select
              onChange={(e) =>
                this.selectedItem("allowSellSpotItensWithoutStock", e)
              }
              className="custom-select"
              value={Number(allowSellSpotItensWithoutStock)}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="clientWithdraw" />
            </p>
            <select
              onChange={(e) => this.selectedItem("clientWithdraw", e)}
              className="custom-select"
              value={Number(clientWithdraw)}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>

          {companyTag === "nortel" && (
            <React.Fragment>
              <div className="form-group">
                <p className="margin-bottom-2">
                  {I18n.t("clientSolicitationType")}
                </p>
                <select
                  onChange={(event) =>
                    this.selectedItem("deliveryAddressType", event)
                  }
                  className="custom-select"
                  value={Number(deliveryAddressType)}
                  required
                >
                  <option value="" />
                  <option value="1">{I18n.t("yes")}</option>
                  <option value="0">{I18n.t("no")}</option>
                </select>
              </div>
              <div className="form-group">
                <p className="margin-bottom-2">
                  {I18n.t("identifyInternalDeliveryLocation")}
                </p>
                <select
                  onChange={(event) =>
                    this.selectedItem("internalDeliveryAddress", event)
                  }
                  className="custom-select"
                  value={Number(internalDeliveryAddress)}
                  required
                >
                  <option value="" />
                  <option value="1">{I18n.t("yes")}</option>
                  <option value="0">{I18n.t("no")}</option>
                </select>
              </div>
              <div className="form-group">
                <p className="margin-bottom-2">
                  <Translate value="clientOrderType" />
                </p>
                <select
                  onChange={(e) => this.selectedItem("orderType", e)}
                  className="custom-select"
                  value={Number(orderType)}
                  required
                >
                  <option value="" />
                  <option value="1">{I18n.t("ParcialBilling")}</option>
                  <option value="0">{I18n.t("TotalBilling")}</option>
                </select>
              </div>
            </React.Fragment>
          )}

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="clientAutoBilling" />
            </p>
            <select
              onChange={(e) => this.selectedItem("autoBilling", e)}
              className="custom-select"
              value={Number(autoBilling)}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="clientCustomerUnit" />
            </p>
            <select
              onChange={(e) => this.selectedItem("customerUnit", e)}
              className="custom-select"
              value={Number(customerUnit)}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>

          {companyTag === "chile" && (
            <div className="form-group">
              <p className="margin-bottom-2">
                {I18n.t("projectsForIntegrators")}
              </p>
              <select
                onChange={(e) => this.selectedItem("projectsForIntegrators", e)}
                className="custom-select"
                value={Number(projectsForIntegrators)}
                required
              >
                <option value="1">{I18n.t("yes")}</option>
                <option value="0">{I18n.t("no")}</option>
              </select>
            </div>
          )}

          {/* {companyTag === 'nortel' &&
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="limitContract" /></p>
              <select
                onChange={e => this.selectedItem('maximumContractLimit', e)}
                className="custom-select"
                value={Number(maximumContractLimit)}
                required
              >
                <option value='0'>{I18n.t('withoutChange')}</option>
                <option value='1'>{I18n.t('limitBlockedContract')}</option>
                <option value='2'>{I18n.t('limitContractNotice')}</option>
              </select>
            </div>} */}

          {this.getSelectComponent(
            I18n.t("punchoutN1Rule"),
            "punchoutRule",
            punchoutRule || "",
            this.getValuesRules(rules)
          )}

          <div className="form-group">
            <p className="margin-bottom-2">PunchOut ID</p>
            <input
              onChange={(e) => this.selectedItem("punchoutVendorId", e)}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={punchoutVendorId || ""}
              maxLength={FIELDS.default}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="newItemVendor" />
            </p>
            <input
              onChange={(e) => this.selectedItem("newItemVendor", e)}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={newItemVendor || ""}
              maxLength={FIELDS.default}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="newItemContract" />
            </p>
            <input
              onChange={(e) => this.selectedItem("newItemContract", e)}
              type="text"
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              value={newItemContract || ""}
              maxLength={FIELDS.default}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="allowPunchoutCatalog" />
            </p>
            <select
              onChange={(e) => this.selectedItem("productCatalogPunchout", e)}
              className="custom-select"
              value={Number(productCatalogPunchout)}
              required
            >
              <option value="" />
              <option value="1">{I18n.t("yes")}</option>
              <option value="0">{I18n.t("no")}</option>
            </select>
          </div>
          {!!productCatalogPunchout && (
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="catalogName" />
              </p>
              <input
                onChange={(e) => this.selectedItem("punchoutCatalogName", e)}
                type="text"
                className="form-control"
                aria-describedby="botãoComprar"
                placeholder=""
                value={punchoutCatalogName}
                maxLength={FIELDS.default}
              />
            </div>
          )}
          {!!productCatalogPunchout &&
            this.getSelectComponent(
              I18n.t("punchoutN2Rule"),
              "punchoutN2Rule",
              punchoutN2Rule || "",
              this.getValuesRules(rulesN2)
            )}

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="clientMinimumPurchase" />
            </p>
            <p>
              <NumberFormat
                className="limit-input"
                value={Number(minimumPurchase)}
                prefix={`${I18n.t("monetarySymbolPrefix")}`}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                onValueChange={(e) => this.setMinimumPurchase(e)}
              />
            </p>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="clientMinimumProduct" />
            </p>
            <p>
              <NumberFormat
                className="limit-input"
                value={Number(minimumProduct)}
                prefix={`${I18n.t("monetarySymbolPrefix")}`}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                onValueChange={(e) => this.setMinimumProduct(e)}
              />
            </p>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="limitText" />
            </p>
            <ApproveLimitComponent
              limits={this.state.form.limits}
              setLimit={this.setLimit}
              newLimit={this.newLimit}
              removeLimit={this.removeLimit}
            />
          </div>

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {!this.props.back.location.item ? (
              <button
                onClick={() => this.saveClient("create")}
                type="button"
                className="btn btn-dark"
              >
                <Translate value="save" />
              </button>
            ) : (
              <button
                onClick={() => this.saveClient("update")}
                type="button"
                className="btn btn-dark"
              >
                <Translate value="update" />
              </button>
            )}
          </div>
        </form>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createClient: data => dispatch(ClientsAction.createClients(data)),
  updateClient: data => dispatch(ClientsAction.updateClients(data)),
  getClientSettings: () => { dispatch(ClientsAction.getClientSettings()); },
  searchSphereClient: (limit, search) => { dispatch(ClientsAction.searchSphereClient(limit, search)); },
});

const mapStateToProps = state => ({
  clients: state.clients.clientsSettings,
  searched: state.clients.searched,
  goalOff: state.settings.goalOff,
  rules: state.settings.punchOutRules,
  rulesN2: state.settings.punchOutN2Rules,
  companyTag: state.settings.companyTag,
  opico: state.settings.name,
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientFormComponent);
